<template>
  <div class="add-user-panel" v-if="dropDownRender">
    <div class="add-user-panel__header">
      <div class="add-user-panel__header-row">
        <div class="add-user-panel__title">{{ title }}</div>
        <IconButton
          size="super-small"
          color="secondary"
          icon="close-icon"
          @click="$emit('close')"
        />
      </div>
      <div class="add-user-panel__search">
        <div class="add-user-panel__search-icon">
          <icon name="search-icon" />
        </div>
        <input
          type="text"
          class="add-user-panel__search-input"
          v-model="search"
        />
        <IconButton
          class="add-user-panel__filter-button"
          size="super-small"
          color="secondary"
          icon="filter-icon"
          @click="active_filter = !active_filter"
        />
        <div class="filter-block" :class="{ active: active_filter }">
          <div class="filter-block__header">
            <h4 class="filter-block__title" style="color: #929baa">מסנן</h4>
            <button class="filter-block__clear-button" @click="category = ''">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.3158 4H13.6842V7.5H20V11H4V7.5H10.3158V4Z"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 20H19V11H5V20Z"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.5 20V16"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 20V16"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.5 20V16"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.94727 20H17.0525"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              נקה הכל
            </button>
          </div>
          <div class="filter-block__body" @click.stop>
            <div class="form__field mb-2">
              <div class="form__field-label">קטגוריה</div>
              <select2 class="form__field-select" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-user-panel__body">
      <div class="add-user-panel__group">
        <div class="add-user-panel__group-body">
          <div class="add-user-panel__group-list">
            <div
              class="add-user-panel__group-item"
              v-for="student in filtered"
              :key="student.user_id"
            >
              <CheckboxNew
                :check="isSelected(student)"
                @checkedElem="selectUser(student)"
              />
              <div class="add-user-panel__group-item-avatar">
                <img :src="student.image_path" alt="" v-avatar-placeholder />
              </div>
              <div class="add-user-panel__group-item-name">
                {{ student.name + ' ' + student.last_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxNew from '@/Components/UI/Form/CheckBoxModal.vue';
// import checkBoxComponent from '@/mixins/checkBoxComponent.js';
// import checkBoxComponent from '@/mixins/checkBoxComponent.js';

import IconButton from '@/Components/UI/Buttons/IconButton.vue';
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';

export default {
  components: { IconButton, CheckboxNew },
  //   mixins: [checkBoxComponent],

  props: {
    title: {
      type: String,
      default: 'הוספת משתמשים'
    },
    dropDownRender: {
      type: Boolean
    },
    users_list: {
      type: Array
    }
  },
  data() {
    return {
      users: [],
      category: 'student-list',
      search: '',
      checkedAll: false,
      active_filter: false,
      categories: []
    };
  },

  computed: {
    filtered() {
      const q = this.search.toLowerCase().trim();
      if (!q) {
        return this.users_list;
      }

      return this.users_list.filter(
        w =>
          (w.last_name || '').toLowerCase().includes(q) ||
          (w.name || '').toLowerCase().includes(q) ||
          (w.personal_number || '').toLowerCase().includes(q) ||
          (w.position_code || '').toString().includes(q)
      );
    },

    ...mapState({
      selectedCampus: s => s.settings.selectedCampus,
      user: state => state.modalUsers.user
    })
  },

  methods: {
    ...mapMutations({
      SET_USER: 'modalUsers/SET_USER'
    }),
    selectUser(user) {
      this.SET_USER(user);
    },
    isSelected(userId) {
      if (userId && userId.user_id && this.user && this.user.user_id) {
        return this.user.user_id === userId.user_id;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-block {
  position: absolute;
  box-shadow: 0px 2px 4px 0px rgba(56, 69, 93, 0.04),
    0px 4px 12px -2px rgba(56, 69, 93, 0.12);
  top: 58px;
  left: 0;
  width: 100%;
  height: calc(100% - 58px);
  min-height: 262px;
  background-color: #fff;
  padding: 12px 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
  opacity: 0;
  transition: 0.3s;
  pointer-events: none;

  &.active {
    opacity: 1;
    pointer-events: all;
  }
  &__close-button {
    display: flex;
    width: 24px;
    height: 24px;
    border: none;
    background-color: transparent;
    margin-bottom: 8px;
    cursor: pointer;
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  &__clear-button {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #929baa;
    border: none;
    background-color: transparent;
    padding: 8px 4px;
  }
  &__body {
    margin-bottom: auto;
  }
}
.add-user-panel {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 692px;
  width: 300px;
  height: 100%;
  border-right: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
  background: var(--background-white, #fff);
  box-shadow: 0px 4px 12px -4px rgba(56, 69, 93, 0.04),
    0px 8px 20px -4px rgba(56, 69, 93, 0.08);
  &__group-list {
    // max-height: 600px;
    overflow: auto;
  }
  &__header {
    width: 100%;
    padding: 16px;
    background: var(--background-white, #fff);
    z-index: 1;
  }
  &__header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  &__title {
    color: var(--dark-grey-tints-main-dark, #38455d);
    text-align: right;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
  &__search {
    position: relative;
    margin-bottom: 16px;
  }
  &__search-icon {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    stroke: var(--dark-grey-tints-main-grey, #8e9ebb);
  }
  &__search-input {
    border-radius: 8px;
    border: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    background: var(--background-white, #fff);
    height: 40px;
    width: 100%;
    padding: 0 44px 0 44px;
    overflow: hidden;
    color: #38455d;
    font-size: 14px;
    font-family: Rubik;
    line-height: 24px;
    &::placeholder {
      color: var(--dark-grey-tints-main-grey, #8e9ebb);
    }
    &:focus {
      outline: none;
    }
  }
  &__filter-button {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
  }
  &__selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__amount {
    border-radius: 16px;
    background: var(--background-extra-grey, #f7f8fa);
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    color: var(--dark-grey-tints-main-dark, #38455d);
    font-size: 14px;
    line-height: 24px;
    stroke: #8e9ebb;
    span {
      min-width: 24px;
      text-align: center;
    }
  }
  &__body {
    overflow-y: auto;
    height: calc(100% - 130px);
  }
  &__group-header {
    border-bottom: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    background: var(--background-extra-grey, #f7f8fa);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--dark-grey-tints-main-dark, #38455d);
    text-align: right;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    position: relative;
    .toggle-button {
      position: absolute;
      transform: translateY(-50%);
      left: 16px;
    }
    .no-rotate {
      top: 50%;
    }
    .rotate {
      transform: scaleY(-1);
    }
  }
  &__group-item {
    padding: 8px 16px 8px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--dark-grey-tints-main-dark, #38455d);
    text-align: right;
    font-size: 14px;
    line-height: 24px;
    &:not(:last-child) {
      border-bottom: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    }
  }
  &__group-item-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
}

@media (max-width: 1023px) {
  .add-user-panel {
    left: 486px;
  }
}

@media (max-width: 786px) {
  .add-user-panel {
    left: 0;
    width: 100%;
  }
}
</style>
